import './styles/style.scss';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener( 'DOMContentLoaded', () => {
	Fancybox.bind( '[data-fancybox]', {} );
	const header = document.querySelector( '.js-header' );
	const navOpen = document.querySelector( '.js-nav-open' );
	if ( ! header ) return;

	const desktopNavMq = window.matchMedia( '(min-width: 1024px)' );

	function closeNavIfDesktop() {
		if ( desktopNavMq.matches ) {
			header.classList.remove( 'is-active' );
			document.body.classList.remove( 'is-nav-open' );
		}
	}

	desktopNavMq.addEventListener( 'change', closeNavIfDesktop );
	closeNavIfDesktop();

	if ( navOpen ) {
		navOpen.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			header.classList.toggle( 'is-active' );
			document.body.classList.toggle(
				'is-nav-open',
				header.classList.contains( 'is-active' )
			);
		} );
	}

	// Header background opacity: full at 100px scroll, smooth transition
	const scrollThreshold = 100;
	function updateHeaderScroll() {
		header.classList.toggle(
			'is-scrolled',
			window.scrollY >= scrollThreshold
		);
	}
	let ticking = false;
	window.addEventListener( 'scroll', () => {
		if ( ! ticking ) {
			requestAnimationFrame( () => {
				updateHeaderScroll();
				ticking = false;
			} );
			ticking = true;
		}
	} );
	updateHeaderScroll();

	// Add expand button for menu items with children
	const parentItems = document.querySelectorAll(
		'li.menu-item-has-children > a'
	);
	parentItems.forEach( ( anchor ) => {
		const span = document.createElement( 'span' );
		span.className = 'menu-expand';
		const button = document.createElement( 'button' );
		button.type = 'button';
		const svg = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg'
		);
		svg.setAttribute( 'class', 'icon icon-arrow-chevron' );
		const use = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'use'
		);
		use.setAttributeNS(
			'http://www.w3.org/1999/xlink',
			'xlink:href',
			'#icon-arrow-chevron'
		);
		svg.appendChild( use );
		button.appendChild( svg );
		span.appendChild( button );
		anchor.appendChild( span );

		span.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			e.stopPropagation();
			const parentLi = span.closest( 'li' );
			if ( parentLi ) parentLi.classList.toggle( 'active' );
		} );
	} );
} );

document.addEventListener( 'DOMContentLoaded', function () {
	const marquees = document.querySelectorAll( '.marquee' );

	marquees.forEach( ( marquee ) => {
		const marqueeInner = marquee.querySelector( '.marquee-inner' );
		if ( ! marqueeInner ) return; // Skip if no inner element found

		const marqueeContent = marquee.querySelector( '.marquee-content' );
		const containerWidth = marquee.offsetWidth;
		let contentWidth = marqueeContent.offsetWidth;
		let speed = 1; // Adjust speed as needed
		let isPaused = false; // Track pause state
		let position = 0;
		let shouldScroll = ! marquee.classList.contains( 'marquee-no-scroll' ); // Use marquee-no-scroll class

		// Only clone content if scrolling is enabled
		if ( shouldScroll ) {
			// Clone content until it fills the container more than twice
			while ( contentWidth < containerWidth * 3 ) {
				const clone = marqueeContent.cloneNode( true );
				marqueeInner.appendChild( clone );
				contentWidth += marqueeContent.offsetWidth;
			}
		}

		function animate() {
			if ( ! isPaused && shouldScroll ) {
				// Only animate if scrolling is enabled
				position -= speed;
				if ( position <= -marqueeContent.offsetWidth ) {
					position += marqueeContent.offsetWidth;
				}
				marqueeInner.style.transform = `translateX(${ position }px)`;
			}
			requestAnimationFrame( animate );
		}

		// Start animation
		animate();
		if ( shouldScroll ) {
			marqueeInner.addEventListener( 'mouseover', function () {
				isPaused = true;
			} );
			marqueeInner.addEventListener( 'mouseleave', function () {
				isPaused = false;
			} );
		}
	} );
} );

( function () {
	'use strict';

	var HEADER_OFFSET = 100;
	var SCROLL_TOP_THRESHOLD = 400;

	var SINGLE_POST_CONFIG = {
		rankMathToc: '#rank-math-toc',
		tocSidebar: '.js-post-toc-sidebar',
		tocMobile: '.js-post-toc-mobile',
		postDetailHolder: '.post-detail-holder',
		blogsSingle: '.blogs-single',
		scrollTopBtn: '.js-blog-scroll-top',
		desktopTocMq: '(min-width: 1024px)',
		noSidebarClass: 'no-sidebar',
	};

	function getActiveTocContainer( sidebar, mobile ) {
		return window.matchMedia( SINGLE_POST_CONFIG.desktopTocMq ).matches
			? sidebar
			: mobile;
	}

	function getScrollOffset() {
		var header = document.querySelector( '.js-header' );
		if ( ! header ) {
			return HEADER_OFFSET;
		}
		return header.getBoundingClientRect().height + 24;
	}

	function scrollToTarget( target, smooth ) {
		if ( ! target ) {
			return;
		}
		var top =
			target.getBoundingClientRect().top +
			window.pageYOffset -
			getScrollOffset();
		window.scrollTo( {
			top: Math.max( 0, top ),
			behavior: smooth ? 'smooth' : 'auto',
		} );
	}

	function scrollToHashOnLoad() {
		var hash = window.location.hash;
		if ( ! hash || hash === '#' ) {
			return;
		}

		var target = document.querySelector( hash );
		if ( ! target ) {
			return;
		}

		requestAnimationFrame( function () {
			scrollToTarget( target, false );
		} );
	}

	function initTocSmoothScroll( sidebar, mobile ) {
		[ sidebar, mobile ].forEach( function ( tocContainer ) {
			if ( ! tocContainer ) {
				return;
			}

			tocContainer.addEventListener( 'click', function ( e ) {
				var link = e.target.closest( 'a[href^="#"]' );
				if ( ! link || ! tocContainer.contains( link ) ) {
					return;
				}

				var hash = link.getAttribute( 'href' );
				if ( ! hash || hash === '#' ) {
					return;
				}

				var target = document.querySelector( hash );
				if ( ! target ) {
					return;
				}

				e.preventDefault();
				scrollToTarget( target, true );

				if ( history.pushState ) {
					history.pushState( null, '', hash );
				} else {
					window.location.hash = hash;
				}
			} );
		} );
	}

	function initSinglePostToc() {
		var blogsSingle = document.querySelector(
			SINGLE_POST_CONFIG.blogsSingle
		);
		if ( ! blogsSingle ) {
			return;
		}

		var holder = document.querySelector(
			SINGLE_POST_CONFIG.postDetailHolder
		);
		var toc = document.querySelector( SINGLE_POST_CONFIG.rankMathToc );
		var sidebar = document.querySelector( SINGLE_POST_CONFIG.tocSidebar );
		var mobile = document.querySelector( SINGLE_POST_CONFIG.tocMobile );

		if ( ! holder || ! sidebar || ! mobile ) {
			return;
		}

		function placeToc() {
			if ( ! toc ) {
				return;
			}
			var target = getActiveTocContainer( sidebar, mobile );
			target.appendChild( toc );
		}

		if ( toc ) {
			placeToc();
			initTocSmoothScroll( sidebar, mobile );
			window
				.matchMedia( SINGLE_POST_CONFIG.desktopTocMq )
				.addEventListener( 'change', placeToc );
		} else {
			holder.classList.add( SINGLE_POST_CONFIG.noSidebarClass );
		}

		scrollToHashOnLoad();
	}

	function initBlogScrollTop() {
		var btn = document.querySelector( SINGLE_POST_CONFIG.scrollTopBtn );
		if ( ! btn ) {
			return;
		}

		function updateScrollTopVisibility() {
			var isMobile = window.matchMedia( '(max-width: 767px)' ).matches;
			btn.classList.toggle(
				'is-visible',
				isMobile && window.pageYOffset >= SCROLL_TOP_THRESHOLD
			);
		}

		btn.addEventListener( 'click', function () {
			window.scrollTo( { top: 0, behavior: 'smooth' } );
		} );

		window.addEventListener( 'scroll', updateScrollTopVisibility, {
			passive: true,
		} );
		window
			.matchMedia( '(max-width: 767px)' )
			.addEventListener( 'change', updateScrollTopVisibility );
		updateScrollTopVisibility();
	}

	function initSinglePostFeatures() {
		initSinglePostToc();
		initBlogScrollTop();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initSinglePostFeatures );
	} else {
		initSinglePostFeatures();
	}
} )();

let lastScrollTop = 0;
const body = document.body;
window.addEventListener(
	'scroll',
	function () {
		let scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		if ( scrollTop > lastScrollTop ) {
			body.classList.add( 'scrolling-down' );
			body.classList.remove( 'scrolling-up' );
		} else {
			body.classList.add( 'scrolling-up' );
			body.classList.remove( 'scrolling-down' );
		}
		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
	},
	false
);
